import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { getActiveBoosts } from '../subscription.service';
import { subscriptionsKeys } from '../subscriptions.keys';
const FIVE_MINUTES = 5 * 60 * 1000;
export const useGetActiveBoosts = (options) => {
    const subdomain = getSubdomain();
    return useQuery({
        queryKey: subscriptionsKeys.activeBoosts(subdomain),
        queryFn: () => getActiveBoosts(subdomain),
        staleTime: FIVE_MINUTES,
        gcTime: FIVE_MINUTES,
        ...(options ?? {}),
    });
};
